import { render } from "./EditPhone.vue?vue&type=template&id=27b0b353&scoped=true"
import script from "./EditPhone.vue?vue&type=script&lang=js"
export * from "./EditPhone.vue?vue&type=script&lang=js"

import "./EditPhone.vue?vue&type=style&index=0&id=27b0b353&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\areaclienti.luceegasitalia.it\\areaclienti\\areaclienti\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27b0b353"]])

export default __exports__